// extracted by mini-css-extract-plugin
export var emailBlockLink = "_q6-0";